import { makeAutoObservable } from "mobx"
import TripDestination from "../models/TripDestination"

export default class TripDestinationList {
  items: TripDestination[]

  constructor(props: any[]) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.items = props.map((destinationProps) => new TripDestination(destinationProps))
  }

  get nonDeleted() {
    return this.items.filter((destination) => destination.delete === false)
  }

  addDestination() {
    this.items.push(new TripDestination({}))
  }

  isFirst(tripDestination: TripDestination): boolean {
    return this.nonDeleted.indexOf(tripDestination) === 0
  }

  isLast(tripDestination: TripDestination): boolean {
    return this.nonDeleted.indexOf(tripDestination) === this.nonDeleted.length - 1
  }

  hasSingleDestination(): boolean {
    return this.nonDeleted.length === 1
  }
}
